module.exports = "/flags723494a45f26bb1427c6d43205333ff1.png";